import { useEffect, useState } from 'react';

/**
 * react-router v4 lacks a hook for the location, and since there's no way to hook into
 * the internal router state, we're doing a bit of magic (bullshit) to synchronize the location.
 */
export function useLocation() {
  const [internalLocation, setInternalLocation] = useState<Location>(window.location);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (window.location.href !== internalLocation.href) {
        setInternalLocation(window.location);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [internalLocation.href]);

  return internalLocation;
}
